<template>
  <div class="content">
    <div class="header">
      <div style="margin: 5px 0">
        <div>
          <SelectCdjProjectHeader :items="['type_id', 'place_id','region_id','project_id']" @onHeader="onHeader">

          </SelectCdjProjectHeader>
          <el-input
            style="width: 240px"
            placeholder="请输入项目"
            v-model="where.text"
            clearable>
          </el-input>
<!--          <el-date-picker-->
<!--            style="width: 150px"-->
<!--            v-model="where.year_month"-->
<!--            size="mini"-->
<!--            type="month"-->
<!--            format="yyyy-MM"-->
<!--            value-format="yyyy-MM">-->
<!--          </el-date-picker>-->

          <el-date-picker
            style="width: 150px"
            v-model="where.start_time"
            size="mini"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM" :clearable="false">
          </el-date-picker>
<!--          <el-date-picker-->
<!--            style="width: 150px"-->
<!--            v-model="where.end_time"-->
<!--            size="mini"-->
<!--            type="month"-->
<!--            format="yyyy-MM"-->
<!--            value-format="yyyy-MM">-->
<!--          </el-date-picker>-->
        </div>
      </div>
    </div>

    <div class="body">
      <el-tabs type="border-card" v-model="card_index">
        <el-tab-pane label="统计" name="LiAnTableStatistics2">
          <LiAnTableStatistics2 v-if="card_index==='LiAnTableStatistics2'" />
        </el-tab-pane>
        <el-tab-pane label="明细" name="LiAnTableStatistics">
          <LiAnTableStatistics v-if="card_index==='LiAnTableStatistics'" />
        </el-tab-pane>
      </el-tabs>
<!--      <LiAnTableStatistics2 />-->
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import LiAnTableStatistics from "./components/LiAnTableStatistics";
import LiAnTableStatistics2 from "./components/LiAnTableStatistics2";
import SelectCdjProjectHeader from "./components/common/SelectCdjProjectHeader";

export default {
  name: "Litigation",
  components: {SelectCdjProjectHeader, LiAnTableStatistics2, LiAnTableStatistics},
  provide(){
    return{
      where:this.where,
      reginWhere:this.reginWhere
    }
  },
  data() {
    return {
      where: {
        text:"",
        type:"",
        type_ex:"",
        start_time:moment(new Date()).format("YYYY-MM"),
        end_time:moment(new Date()).format("YYYY-MM"),
        // year_month:moment(new Date()).format("YYYY-MM"),
      },

      type_list:[],
      project_region_list:[],
      reginWhere:{
        type_id:"",
        type_list:[],
        project_region:"",
        project_region_list:[],
        project_name:"",
        project_list:[],
        group_by:"",
        area_id:"",
        area_list:[],
        project_ids:[]
      },
      card_index:"LiAnTableStatistics2"
    }
  },
  mounted() {

  },
  activated() {
    const that=this;
  },
  methods: {
    onHeader(data){
      const that=this;
      that.reginWhere.type_id=data.type_id;
      that.reginWhere.type_list=data.type_list;
      that.reginWhere.project_region=data.project_region;
      that.reginWhere.project_region_list=data.project_region_list;
      that.reginWhere.project_region_level=data.project_region_level;
      that.reginWhere.project_name=data.project_name;
      that.reginWhere.project_list=data.project_list;
      that.reginWhere.group_by=data.group_by;
      that.reginWhere.area_id=data.area_id;
      that.reginWhere.area_list=data.area_list;
      that.reginWhere.project_ids=data.project_ids;
      that.reginWhere.level=data.level;
      that.is_loading=true;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "common";

.content{
  padding: 20px;

  .header{

  }
  .body{
    width: 100%;
    //overflow-x: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/LitigationStatistics.vue